<template>
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div class="kt-portlet kt-portlet--mobile">
            <div class="kt-portlet__head kt-portlet__head--lg no-border-radius">
                <Dropdown v-model="selectedOrg" :options="organizations" optionLabel="display_name"
                    :placeholder="$t('AppAlertsCoa.Organização')" class="auto-center" :dataKey="'id'" :filter="true"
                    @input="saveChosenOptionsToLocalStorage" style="width: 250px">
                    <template #option="slotProps" style="width: 500px">
                        <div v-if="loadingOrgs"> {{ $t('AppAlertsCoa.Carregando, aguarde') }}</div>
                        <div style="padding-right: 20px" v-else-if="slotProps.option.name === 'ND'">
                            -
                        </div>
                        <div style="padding-right: 20px" v-else>
                            {{ slotProps.option.display_name }}
                        </div>
                    </template>
                </Dropdown>
            </div>
            <div class="kt-portlet__body no-padding" id="tableDiv">
                <div class="card data-table-width">
                    <DataTable :value="gridData" :paginator="true" :rows="50" :rowHover="true" :loading="loading" filterDisplay="row" :filters.sync="filters"
                        :sortOrder="-1" sortField="last_alert_time" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        :rowsPerPageOptions="[10, 25, 50]" responsiveLayout="scroll"
                        :currentPageReportTemplate="$t('AppAlertsCoa.Mostrando {first} até {last} de {totalRecords} Alertas')"
                        class="p-datatable-striped">

                        <template #header>
                            <span style="font-size: 20px; font-weight: 500;">{{$t('AppAlertsCoa.Tela do COA')}}</span>
                        </template>
                        <template #empty>
                            {{$t('AppAlertsCoa.Sem dados para exibir')}}
                        </template>

                        <Column field="code_alert" :header="$t('AppAlertsCoa.Código do Alerta')" headerClass="headerClass" :showFilterMenu="false" :styles="{'max-width': '9rem', 'min-width': '6rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.code_alert }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="criticality_level" :header="$t('AppAlertsCoa.Criticidade')" headerClass="headerClass" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span :class="'badge criticalityLevel-' + slotProps.data.criticality_level">
                                    {{ getCriticalityLevel(slotProps.data.criticality_level) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsCriticalityLevel"
                                            :placeholder="$t('AppAlertsCoa.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge criticalityLevel-' + singleValue" style="margin-right: 5px;">
                                            {{ getCriticalityLevel(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge criticalityLevel-' + slotProps.option.code">
                                            {{ getCriticalityLevel(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>
                        <Column field="fleet" :header="$t('AppAlertsCoa.Frota')" headerClass="headerClass" :showFilterMenu="false" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.fleet }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsFleet"
                                            :placeholder="$t('AppAlertsCoa.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name"  />
                            </template>
                        </Column>
                        <Column field="class_name" :header="$t('AppAlertsCoa.Classe')" headerClass="headerClass" :showFilterMenu="false" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.class_name }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsClass"
                                            :placeholder="$t('AppAlertsCoa.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="front" :header="$t('AppAlertsCoa.Frente')" headerClass="headerClass" :showFilterMenu="false" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ slotProps.data.front }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsFront"
                                            :placeholder="$t('AppAlertsCoa.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="name" />
                            </template>
                        </Column>
                        <Column field="hour_last_alert_value" :header="$t('AppAlertsCoa.Data/Hora Último Alerta')" headerClass="headerClass" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_last_alert_value) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hours_without_communication" :header="$t('AppAlertsCoa.Horas Sem Comunicação')" headerClass="headerClass" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ getTimeFromSecondsDurationFormatMixin(slotProps.data.hours_without_communication)
                                    }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="hour_of_receipt_of_coa" :header="$t('AppAlertsCoa.Data/Hora de Recebimento do COA')" headerClass="headerClass" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showFilterMenu="false" :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour_of_receipt_of_coa) }}</span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <InputText type="text" v-model="filterModel.value" @input="filterCallback()" class="p-column-filter"/>
                            </template>
                        </Column>
                        <Column field="status" :header="$t('AppAlertsCoa.Status')" headerClass="headerClass" :showFilterMenu="false" :styles="{'min-width': '6rem', 'max-width': '9rem'}"
                            :showClearButton="false" bodyClass="bodyClass" :sortable="true">
                            <template #body="slotProps">
                                <span :class="'badge status-' + slotProps.data.status">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                            <template #filter="{filterModel,filterCallback}">
                                <MultiSelect v-model="filterModel.value" @input="filterCallback()" :options="optionsStatus"
                                            :placeholder="$t('AppAlertsCoa.Selecione')" appendTo="tableDiv"
                                            class="p-column-filter width-multiselect" :showClear="true" optionLabel="name" optionValue="code">
                                    <template #value="slotProps">
                                        <span v-for="singleValue in slotProps.value" :class="'badge status-' + singleValue" style="margin-right: 5px;">
                                            {{ getStatus(singleValue) }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <span :class="'badge status-' + slotProps.option.code">
                                            {{ getStatus(slotProps.option.code) }}
                                        </span>
                                    </template>
                                </MultiSelect>
                            </template>
                        </Column>

                        <Column :header="$t('AppAlertsCoa.Mensagem do Problema')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '6rem'}" >
                            <template #body="slotProps">
                                <Button style="margin-right: 5px" @click="handleAnalyse(slotProps.data)"
                                    :label="$t('AppAlertsCoa.Analisar')" />
                            </template>
                        </Column>
                        <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '4rem'}" >
                            <template #body="slotProps">
                                <Button icon="pi pi-pencil" class="p-button-rounded p-button-success"
                                    style="margin-right: 5px" @click="handleEdit(slotProps.data)" />
                            </template>
                        </Column>
                    </DataTable>
                </div>

                <Dialog header="Analisar" :visible.sync="viewMessage" :modal="true" :contentStyle="{ 'width': '900px', 'max-height': '80vh', 'font-size': '14px' }">
                    <!-- Header -->
                    <div class="row p-0 m-0 mb-2" style="display: flex; justify-content: space-between;">
                        <div>{{$t('AppAlertsCoa.Recebimento do COA:')}} {{ dateHourFormat(dataToAnalyse.hour_of_receipt_of_coa) || '-' }}</div>
                        <div>{{$t('AppAlertsCoa.Tipo de Alerta - ')}} {{ $t(`AppAlertsCoaHistorical.${dataToAnalyse.type_alert}`) }}</div>
                    </div>
                    <!-- Maquina -->
                    <div class="row p-0 m-0" style="border: 1px solid rgba(0, 0, 0, 0.2); height: auto; border-radius: 3px; margin-top: 10px;">
                        <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                            {{$t('AppAlertsCoa.Máquina')}}
                        </div>
                        <div style="width: 100%; display: flex; justify-content: space-around; align-items: center; margin: 15px 0 15px 0;">
                            <div style="flex: 1; text-align: center;">
                                {{$t('AppAlertsCoa.Frota')}}<br>
                                {{ dataToAnalyse.fleet || '-' }}
                            </div>
                            <div style="flex: 1; text-align: center;">
                                {{$t('AppAlertsCoa.Classe')}}<br>
                                {{ dataToAnalyse.class_name || '-' }}
                            </div>
                            <div style="flex: 1; text-align: center;">
                                {{$t('AppAlertsCoa.Frente')}}<br>
                                {{ dataToAnalyse.front || '-' }}
                            </div>
                            <div style="flex: 1; text-align: center;">
                                {{$t('AppAlertsCoa.Última Comunicação')}}<br>
                                {{ dateHourFormat(dataToAnalyse.hour_last_communication) || '-' }}
                            </div>
                            <div style="flex: 1; text-align: center;">
                                {{$t('AppAlertsCoa.Sem Comunicação')}}<br>
                                {{ getTimeFromSecondsDurationFormatMixin(dataToAnalyse.hours_without_communication) || '-' }}
                            </div>
                        </div>
                    </div>
                    <!-- Mensagem / Criticidade e Status -->
                    <div class="row p-0 m-0 mt-3 mb-3">
                        <div class="col-10 p-0 m-0 pr-3">
                            <div style="border: 1px solid rgba(0, 0, 0, 0.2); height: 100%; border-radius: 3px;">
                                <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                        text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                                    {{$t('AppAlertsCoa.Mensagem')}}
                                </div>
                                <div style="width: 100%; padding: 15px;" v-if="dataToAnalyse.type_alert != 'machine'">
                                    {{ dataToAnalyse.message }}
                                    <br>
                                    {{$t('AppAlertsCoa.Ocorrências')}}: {{ dataToAnalyse.count }}
                                </div>
                                <div style="width: 100%; padding: 15px;" v-else>
                                    {{ dataToAnalyse.code_alert }} - {{ dataToAnalyse.message }}
                                    <br>
                                    {{ dataToAnalyse.machine_alert_status === 'ENABLED' ? $t('AppAlertsCoa.Alerta Ativo') : $t('AppAlertsCoa.Alerta Inativo') }}
                                    <br>
                                    {{$t('AppAlertsCoa.Ocorrências')}}: {{ dataToAnalyse.count }}
                                </div>
                            </div>
                        </div>
                        <div class="col-2 p-0 m-0">
                            <div class="mb-3" style="border: 1px solid rgba(0, 0, 0, 0.2); height: auto; border-radius: 3px;">
                                <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                    text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                                    {{$t('AppAlertsCoa.Criticidade')}}
                                </div>
                                <div style="width: 100%; text-align: center; padding: 10px; align-items: center; justify-content: center; display: flex;">
                                    <span :class="'badge criticalityLevel-' + dataToAnalyse.criticality_level">
                                        {{ getCriticalityLevel(dataToAnalyse.criticality_level) }}
                                    </span>
                                </div>
                            </div>
                            <div style="border: 1px solid rgba(0, 0, 0, 0.2); height: auto; border-radius: 3px;">
                                <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                    text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                                    {{$t('AppAlertsCoa.Status')}}
                                </div>
                                <div style="width: 100%; text-align: center; padding: 10px; align-items: center; justify-content: center; display: flex;">
                                    <span :class="'badge status-' + dataToAnalyse.status">
                                        {{ getStatus(dataToAnalyse.status) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Simples -->
                    <div v-if="dataToAnalyse.type_alert === 'simple'" style="border: 1px solid rgba(0, 0, 0, 0.2); height: auto; border-radius: 3px;"
                            class="row p-0 m-0 mt-3">
                        <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                            {{ dataToAnalyse.sensor_name }}
                        </div>
                        <div style="width: 100%; display: flex; justify-content: space-around; align-items: center; margin: 20px 0; gap: 20px; padding: 0 20px;">
                            <div style="flex: 1;">
                                <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                    <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                        {{$t('AppAlertsCoa.Última Medição')}}
                                    </span>
                                    {{$t('AppAlertsCoa.Valor')}}<br>
                                    {{ dataToAnalyse.last_measured_value }}<br><br>
                                    {{$t('AppAlertsCoa.Data/Hora')}}<br>
                                    {{ dateHourFormat(dataToAnalyse.hour_last_measured_value) }}<br>
                                </div>
                            </div>
                            <div style="flex: 1;">
                                <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                    <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                        {{$t('AppAlertsCoa.Último Alerta')}}
                                    </span>
                                    {{$t('AppAlertsCoa.Valor')}}<br>
                                    {{ dataToAnalyse.alert_value }}<br>
                                    <br>
                                    {{$t('AppAlertsCoa.Data/Hora')}}<br>
                                    {{ dateHourFormat(dataToAnalyse.hour_last_alert_value) }}<br>
                                </div>
                            </div>
                            <div style="flex: 1;">
                                <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                    <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                        {{$t('AppAlertsCoa.Regras')}}
                                    </span>
                                    {{$t('AppAlertsCoa.Maior que')}} {{ formatValue(dataToAnalyse.value_min) }}<br>
                                    {{$t('AppAlertsCoa.Menor que')}} {{ formatValue(dataToAnalyse.value_max) }}<br>
                                    {{$t('AppAlertsCoa.Tempo mínimo')}}: {{ dataToAnalyse.alert_time }} {{ $t('AppAlertsCoa.segundos') }}<br>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Composto -->
                    <div v-if="dataToAnalyse.type_alert === 'composite'" style="overflow-x: auto; height: 380px;">
                        <div v-for="sensor in dataToAnalyse.sensor_list" style="border: 1px solid rgba(0, 0, 0, 0.2); height: auto; border-radius: 3px; margin-bottom: 10px;"
                            class="row p-0 m-0 mt-3">
                            <div style="width: 100%; height: 40px; background-color: rgba(0, 0, 0, 0.1); border-bottom: 1px solid rgba(0, 0, 0, 0.2); 
                                    text-align: center; align-items: center; display: flex; flex-direction: column; justify-content: center; font-weight: bold; font-size: 16px;">
                                {{ sensor.sensor_name }}
                            </div>
                            <div style="width: 100%; display: flex; justify-content: space-around; align-items: center; margin: 20px 0; gap: 20px; padding: 0 20px;">
                                <div style="flex: 1;">
                                    <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                        <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                            {{$t('AppAlertsCoa.Última Medição')}}
                                        </span>
                                        {{$t('AppAlertsCoa.Valor')}}<br>
                                        {{ sensor.last_measured_value }}<br><br>
                                        {{$t('AppAlertsCoa.Data/Hora')}}<br>
                                        {{ dateHourFormat(sensor.hour_last_measured_value) }}<br>
                                    </div>
                                </div>
                                <div style="flex: 1;">
                                    <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                        <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                            {{$t('AppAlertsCoa.Último Alerta')}}
                                        </span>
                                        {{$t('AppAlertsCoa.Valor')}}<br>
                                        {{ sensor.alert_value }}<br>
                                        <br>
                                        {{$t('AppAlertsCoa.Data/Hora')}}<br>
                                        {{ dateHourFormat(dataToAnalyse.hour_last_alert_value) }}<br>
                                    </div>
                                </div>
                                <div style="flex: 1;">
                                    <div style="position: relative; border-radius: 5px; border: 1px solid rgba(0, 0, 0, 0.2); height: auto; padding: 18px 10px 15px 10px; margin: 8px 0 0 0;">
                                        <span style="position: absolute; top: -12px; left: 10px; background: white; padding: 0 10px; font-weight: bold; font-size: 15px;">
                                            {{$t('AppAlertsCoa.Regras')}}
                                        </span>
                                        {{ getOperation(sensor.rule_first_type) }}
                                        {{ formatValue(sensor.rule_first_value) }}<br>
                                        {{ sensor.rule_logical_operator }}<br>
                                        {{ getOperation(sensor.rule_second_type) }}
                                        {{ formatValue(sensor.rule_second_value) }}<br>
                                        {{ $t('AppAlertsCoa.Tempo mínimo') }}: {{ sensor.alert_time }} {{ $t('AppAlertsCoa.segundos') }}<br>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Algoritmo -->
                    <div v-if="dataToAnalyse.type_alert === 'algorithm'">
                        {{$t('AppAlertsCoa.Data/Hora da Última Ocorrência')}}: {{ dateHourFormat(dataToAnalyse.hour_last_alert_value) }}
                    </div>
                    <!-- Máquina -->
                    <div v-if="dataToAnalyse.type_alert === 'machine'">
                        {{$t('AppAlertsCoa.Data/Hora da Última Ocorrência')}}: {{ dateHourFormat(dataToAnalyse.hour_last_alert_value) }}
                    </div>
                </Dialog>

                <Dialog :header="$t('AppAlertsCoa.Alerta')" :visible.sync="alertDialog" :modal="true" :contentStyle="{ 'max-width': '90vw', 'width': '886px' }">
                    <div class="container-dialog">
                        <div class="container-dialog-first">
                            <div style="font-size: 16px; font-weight: 500; margin: 7.5px 0 7.5px 0;">{{$t('AppAlertsCoa.Ordem de Serviço')}}</div>

                            <div style="margin-bottom: 6px; font-size: 13px;">{{$t('AppAlertsCoa.Responsável')}}</div>
                            <InputText v-model="form.responsible" style="width: 100%; height: 38px; margin-bottom: 20px;" type="text"
                                :class="{'p-invalid': $v.form.responsible.$error && $v.form.responsible.$dirty}"/>

                            <div style="margin-bottom: 6px; font-size: 13px;">{{$t('AppAlertsCoa.Status')}}</div>
                            <Dropdown v-model="form.status" :options="optionsStatusCoa"
                                    style="width: 100%; height: 38px; margin-bottom: 20px;" :showClear="true" optionLabel="code" optionValue="code"
                                    :class="{'p-invalid': $v.form.status.$error && $v.form.status.$dirty}">
                                <template #value="slotProps">
                                    <span :class="'badge status-' + slotProps.value" style="margin-right: 5px;">
                                        {{ getStatus(slotProps.value) }}
                                    </span>
                                </template>
                                <template #option="slotProps">
                                    <span :class="'badge status-' + slotProps.option.code">
                                        {{ getStatus(slotProps.option.code) }}
                                    </span>
                                </template>
                            </Dropdown>
                            <section v-if="form.status && form.status === 'FINISHED'">
                                <div style="margin-bottom: 6px; font-size: 13px;">{{$t('AppAlertsCoa.Tratativa')}}</div>
                                <Dropdown v-model="form.handling" :options="optionsHandling" :class="{'p-invalid': !form.handling}"
                                        style="width: 100%; height: 38px; margin-bottom: 20px;" :showClear="true" optionLabel="name" optionValue="code" />
                            </section>

                            <div style="margin-bottom: 6px; font-size: 13px;">{{$t('AppAlertsCoa.Comentário')}}</div>
                            <Textarea v-model="form.comment" :autoResize="true" rows="5" style="width: 100%; margin-bottom: 11px;"
                                :class="{'p-invalid': $v.form.comment.$error && $v.form.comment.$dirty}" />

                            <app-button type="primary" @handleClick="saveServiceOrder"
                                :class="{ 'kt-spinner kt-spinner--v2 kt-spinner--right kt-spinner--sm kt-spinner--dark': loagindHandleStatus }">
                                <i class="pi pi-check" />
                                {{$t('AppAlertsCoa.Salvar')}}
                            </app-button>
                        </div>
                        <div class="container-dialog-second">
                            <div style="font-size: 16px; font-weight: 500; margin: 7.5px 0 7.5px 0;">{{$t('AppAlertsCoa.Mapa')}}</div>
                            <div v-if="lat && lng && !loadingVehiclePosition">
                                <AppAlertsCoaGoogleMaps :lat="lat" :lng="lng" :style="{height: getHeightMap}"
                                    style="width: 100%; border-radius: 5px; margin-bottom: 15px;" />

                                <app-button type="primary" @handleClick="copyLinkMaps"
                                    :class="{ 'kt-spinner kt-spinner--v2 kt-spinner--right kt-spinner--sm kt-spinner--dark': loagindHandleStatus }">
                                    <i class="pi pi-share-alt" />
                                    {{$t('AppAlertsCoa.Compartilhar')}}
                                </app-button>
                            </div>
                            <div v-else-if="!lat && !lng && loadingVehiclePosition" :style="{height: getHeightMap}" style="display: flex; flex-direction: column; justify-content: center">
                                <ProgressSpinner/>
                            </div>
                            <div v-else>
                                {{$t('AppAlertsCoa.Nada para apresentar')}}
                            </div>
                        </div>
                    </div>

                    <DataTable :value="gridDataHistoricalAlert" :paginator="true" :rows="4" :rowHover="true"
                        :loading="loadingHistoricalAlert" :sortOrder="-1" sortField="last_alert_time" stripedRows
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        responsiveLayout="scroll" style="margin-top: 15px;"
                        :currentPageReportTemplate="$t('AppAlertsCoa.Mostrando {first} até {last} de {totalRecords} Alertas')"
                        class="p-datatable-striped">

                        <template #header>
                            <span style="font-size: 16px; font-weight: 500;">{{$t('AppAlertsCoa.Histórico do alerta')}}</span>
                        </template>
                        <template #empty>
                            {{$t('AppAlertsCoa.Sem dados para exibir')}}
                        </template>

                        <Column field="user_name" :header="$t('AppAlertsCoa.Usuário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}"/>
                        <Column field="assignee" :header="$t('AppAlertsCoa.Responsável')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}" />
                        <Column field="hour" :header="$t('AppAlertsCoa.Horário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <span>{{ dateHourFormat(slotProps.data.hour) }}</span>
                            </template>
                        </Column>
                        <Column field="status" :header="$t('AppAlertsCoa.Status')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <span :class="'badge status-' + slotProps.data.status">
                                    {{ getStatus(slotProps.data.status) }}
                                </span>
                            </template>
                        </Column>
                        <Column field="comment" :header="$t('AppAlertsCoa.Comentário')" headerClass="headerClass" bodyClass="bodyClass" :styles="{'min-width': '9rem'}">
                            <template #body="slotProps">
                                <div v-if="slotProps.data.comment != null && slotProps.data.comment.length > 20" v-tooltip.top="`${slotProps.data.comment}`">
                                    {{ slotProps.data.comment.slice(0, 20) + ' ...' }}
                                </div>
                                <div v-else>
                                    {{ slotProps.data.comment }}
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </Dialog>
            </div>
        </div>
    </div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
import MultiSelect from 'primevue/multiselect';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button/Button';
import Dialog from 'primevue/dialog/Dialog';
import AppButton from '../../../common/AppButton.vue';
import {STATUSES, STATUSES_COA, CRITICALY_LEVELS, HANDLINGS, ALERT_TYPE, STATUSES_ALERT} from '../AppOptionsCoa';
import AppAlertsCoaGoogleMaps from './AppAlertsCoaGoogleMaps';
import OrganizationsService from "@/services/OrganizationsService";
import Textarea from 'primevue/textarea';
import Tooltip from 'primevue/tooltip';
import ProgressSpinner from 'primevue/progressspinner';
import AlertsCoaService from '../../../../services/AlertsCoaService';
import orderCustomFieldByNaturalOrder from "@/mixins/ArrayMixin";
import dateHourFormat from "@/mixins/DateMixin";
import getTimeFromSecondsDurationFormatMixin from "@/mixins/DateMixin";
import VehiclesService from "@/services/VehiclesService";
import sendWhatsAppAlertServiceOrderMessage from "../../../../mixins/WhatsAppMixin"
import {required} from 'vuelidate/lib/validators';
import displayToast from '@/mixins/ToastMixin';
import formatValue from '@/mixins/ValuesFormat';
import {mapGetters} from "vuex";
import {FilterMatchMode} from 'primevue/api';
import {FilterService} from 'primevue/api';
const DATE_FILTER = 'DATE FILTER';
const TS_TO_HOURS = 'TS TO HOURS';
import HourFormatMixin from "@/mixins/HourFormatMixin";

export default {
    mixins: [orderCustomFieldByNaturalOrder, dateHourFormat, getTimeFromSecondsDurationFormatMixin, sendWhatsAppAlertServiceOrderMessage, displayToast, formatValue, HourFormatMixin],
    created() {
        this.organizationsService = new OrganizationsService();
        this.alertsCoaService = new AlertsCoaService();
        this.vehicleService = new VehiclesService();
    },
    mounted: function () {
        this.getOrganizations();
        this.requireNotificationPermission();
        this.stompjsClientSubscribeId = this.user.user_email;
        FilterService.register(DATE_FILTER, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.dateHourFormat(value).includes(filter);
        });
        FilterService.register(TS_TO_HOURS, (value, filter) => {
            if (filter === undefined || filter === null || filter.trim() === '') {
                return true;
            }
            if (value === undefined || value === null) {
                return false;
            }
            return this.getTimeFromSecondsDurationFormatMixin(value).includes(filter);
        });
    },
    beforeDestroy() {
        this.closeWebSocket();
    },
    data() {
        return {
            loagindHandleStatus: false,
            loading: false,
            organizationsService: null,
            alertsCoaService: null,
            loadingOrgs: false,
            selectedOrg: null,
            organizations: [],
            storedChosenOptions: {},
            gridData: [],
            alertDialog: false,
            dataToAnalyse: '',
            viewMessage: false,
            gridDataHistoricalAlert: [],
            loadingHistoricalAlert: false,
            loadingVehiclePosition: false,
            lat: null,
            lng: null,
            optionsFleet: [],
            optionsClass: [],
            optionsFront: [],
            optionsSensorName: [],
            optionsStatus: STATUSES,
            optionsStatusCoa: STATUSES_COA,
            optionsHandling: HANDLINGS,
            optionsCriticalityLevel: CRITICALY_LEVELS,
            optionsAlertType: ALERT_TYPE,
            optionsStatusesAlert: STATUSES_ALERT,
            form: {},
            itemToEdit: null,
            filters: {
                'code_alert': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'criticality_level': {value: null, matchMode: FilterMatchMode.IN},
                'fleet': {value: null, matchMode: FilterMatchMode.IN},
                'class_name': {value: null, matchMode: FilterMatchMode.IN},
                'front': {value: null, matchMode: FilterMatchMode.IN},
                'hour_last_alert_value': {value: null, matchMode: DATE_FILTER},
                'hours_without_communication': {value: null, matchMode: TS_TO_HOURS},
                'hour_of_receipt_of_coa': {value: null, matchMode: DATE_FILTER},
                'status': {value: null, matchMode: FilterMatchMode.IN}
            },
            stompjsClient: null,
            stompjsClientSubscribeId: null,
            vehicleService: null,
            refreshVehiclesInfo: null
        }
    },
    methods: {
        requireNotificationPermission() {
            if (Notification.permission === 'default') {
                Notification.requestPermission().then((permission) => {
                    if (permission === 'denied') {
                        this.displayToast('Permissão negada', 'w', null, 'Ao receber um novo alerta, você não será notificado')
                    }
                })
            }
        },
        getOperation(val){
            switch (val) {
                case '>':
                    return this.$t('AppAlertsCoa.Maior que');
                case '<':
                    return this.$t('AppAlertsCoa.Menor que');
                case '>=':
                    return this.$t('AppAlertsCoa.Maior igual');
                case '<=':
                    return this.$t('AppAlertsCoa.Menor igual');
                case '!=':
                    return this.$t('AppAlertsCoa.Diferente de');
                default:
                    return ''
            }
        },
        getAlertTypeText(value){
            switch (value) {
                case 'simple':
                    return this.$t('AppAlertsCoa.Alerta Simples');
                case 'composite':
                    return this.$t('AppAlertsCoa.Alerta Composto');
                case 'algorithm':
                    return this.$t('AppAlertsCoa.Alerta de Algoritmo');
                case 'machine':
                    return this.$t('AppAlertsCoa.Alerta de Máquina');
                default:
                    return ''
            }
        },
        getOrganizations() {
            this.loadingOrgs = true;
            this.organizationsService.getAllV3('VEHICLES').then((results) => {
                this.populateOrgsList(results);
                this.loadFilteredOptions();
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoa.Não foi possível buscar organizações'), 'e', error)
            }).finally(() => {
                this.loadingOrgs = false;
            })
        },
        populateOrgsList(orgs) {
            this.organizations = this.orderCustomFieldByNaturalOrder(orgs, "name");
        },
        loadFilteredOptions() {
            this.storedChosenOptions = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS));

            if (!this.storedChosenOptions || !this.storedChosenOptions.clients || this.storedChosenOptions.clients.length === 0) {
                this.storedChosenOptions = {};
                return;
            }

            this.selectedOrg = this.storedChosenOptions['clients'].filter(a => this.organizations.some(b => a.id === b.id))[0];
        },
        saveChosenOptionsToLocalStorage() {
            this.storedChosenOptions['clients'] = [this.selectedOrg];
            this.storedChosenOptions['vehicles'] = [];
            localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_FILTER_BAR_OPTIONS, JSON.stringify(this.storedChosenOptions));
        },
        handleEdit(val) {
            this.alertDialog = true;
            this.$v.form.$reset();
            this.form = {}
            this.itemToEdit = val
            this.lat = val.latitude
            this.lng = val.longitude
            this.getStatusHistoricalAlert(val)
        },
        getStatusHistoricalAlert(val){
            this.loadingHistoricalAlert = true
            this.alertsCoaService.getStatusHistoricalAlert(this.selectedOrg.id, val.id).then((data) => {
                this.gridDataHistoricalAlert = data
            }).catch((error) => {
                this.displayToast(this.$t('AppAlertsCoa.Não foi possível buscar os status'), 'e', error)
            }).finally(() => {
                this.loadingHistoricalAlert = false;
            })
        },
        handleAnalyse(val) {
            this.dataToAnalyse = val
            this.viewMessage = true
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({ code }) => code === status);
            if (result) {
                return result.name;
            }
        },
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({ code }) => code === status);
            if (result) {
                return result.name;
            }
        },
        getAlertType(alertType) {
            let result = this.optionsAlertType.find(({code}) => code === alertType);
            if (result) {
                return result.name;
            }
        },
        getStatusesAlert(statusesAlert) {
            let result = this.optionsStatusesAlert.find(({code}) => code === statusesAlert);
            if (result) {
                return result.name;
            }
        },
        uniquePush(array, name) {
            if (name != null && name != undefined && array.length === 0) {
                array.push({ code: array.length, name });
                return
            }

            if ((name != null && name != undefined) && !array.some(item => item.name === name)) {
                array.push({ code: array.length, name });
            }
        },
        copyLinkMaps(){
            let item = this.gridDataHistoricalAlert[0];
            if(item === -1){
                this.displayToast(this.$t('AppAlertsCoa.Por favor crie uma ordem de serviço'), 'e')
                return
            }

            let form = {
                assignee: item.assignee,
                status: this.getStatus(item.status),
                fleet: this.itemToEdit.fleet,
                sensor_name: this.itemToEdit.sensor_name,
                comment: item.comment,
                hour_last_alert_value: this.itemToEdit.hour_last_alert_value,
                alert_value: this.itemToEdit.alert_value,
                lat: this.lat,
                lng: this.lng
            }
            this.sendWhatsAppAlertServiceOrderMessage(form)
        },
        saveServiceOrder(){
            this.$v.form.$touch();
            if ((!this.$v.form.$invalid && this.form.status != 'FINISHED') || (!this.$v.form.$invalid && this.form.status === 'FINISHED' && this.form.handling != undefined)) {
                let data = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE));
                let params = {
                    status: this.form.status,
                    handling: this.form.handling ? this.form.handling : null,
                    comment: this.form.comment,
                    assignee: this.form.responsible,
                    user_name: data.name,
                    user_id: data.id
                };
                this.alertsCoaService.postStatusHistoricalAlert(this.selectedOrg.id, this.itemToEdit.id, params).then((data) => {
                    this.alertDialog = false
                    this.displayToast(this.$t('AppAlertsCoa.Salvo com sucesso'), 's')
                    this.closeWebSocket()
                    this.getAlertsCoa(this.selectedOrg)
                }).catch((error) => {
                    this.gridData = []
                    this.displayToast(this.$t('AppAlertsCoa.Operação falhou'), 'e', error)
                })
            } else {
                this.displayToast(this.$t('AppAlertsCoa.Por favor preencha todos os campos obrigatórios'), 'e')
            }
        },
        getAlertsCoa(val){
            this.loading = true
            this.alertsCoaService.getAlertsCoa(val.id).then((data) => {
                data.forEach(element => {
                    this.uniquePush(this.optionsFleet, element.fleet);
                    this.uniquePush(this.optionsClass, element.class_name);
                    this.uniquePush(this.optionsFront, element.front);
                    this.uniquePush(this.optionsSensorName, element.sensor_name);
                    element.alert_value = this.formatValue(element.alert_value) + ' ' + element.unit
                    element.last_measured_value = this.formatValue(element.last_measured_value) + ' ' + element.unit

                    if(element.sensor_list) {
                        element.sensor_list.forEach(element => {
                            if(element.alert_value && element.unit){
                                element.alert_value = this.formatValue(element.alert_value) + ' ' + element.unit
                            }

                            if(element.last_measured_value && element.unit){
                                element.last_measured_value = this.formatValue(element.last_measured_value) + ' ' + element.unit
                            }
                        });
                    }
                });
                this.gridData = data
                this.scheduledGetVehiclesInfo()
                this.connectWebSocket(val.id);
            }).catch((error) => {
                this.gridData = []
                this.displayToast(this.$t('AppAlertsCoa.Não foi possível buscar os alertas'), 'e', error)
            }).finally(() => {
                this.loading = false;
            })
        },
        connectWebSocket(orgId) {
            const vm = this;
            const accessToken = vm.user.access_token;
            const url = `${process.env.VUE_APP_BACKEND_ADDRESS.replace(/^http/, 'ws')}/parametric-failures-service-ws?access_token=${accessToken}&org_id=${orgId}`;

            vm.ws = new WebSocket(url);

            vm.ws.onmessage = (event) => {
                let receivedAlert = JSON.parse(event.data);
                receivedAlert = vm.transformKeys(receivedAlert);

                if(receivedAlert.hour_alert_end != null){
                    let updatedGridData = vm.gridData.filter(element => element.id !== receivedAlert.id);
                    vm.gridData = [...updatedGridData];
                    return
                }

                vm.uniquePush(vm.optionsFleet, receivedAlert.fleet);
                vm.uniquePush(vm.optionsClass, receivedAlert.class_name);
                vm.uniquePush(vm.optionsFront, receivedAlert.front);
                vm.uniquePush(vm.optionsSensorName, receivedAlert.sensor_name);
                receivedAlert.alert_value = vm.formatValue(receivedAlert.alert_value) + ' ' + receivedAlert.unit
                receivedAlert.last_measured_value = vm.formatValue(receivedAlert.last_measured_value) + ' ' + receivedAlert.unit

                let updatedGridData = vm.gridData.map(element =>
                    element.id === receivedAlert.id ? receivedAlert : element
                );

                if (!updatedGridData.some(element => element.id === receivedAlert.id)) {
                    this.notifyNewAlert(receivedAlert);
                    updatedGridData.push(receivedAlert);
                }

                vm.gridData = [...updatedGridData];
            };
        },
        notifyNewAlert(newAlert) {
            let title = this.$t('AppAlertsCoa.Novo alerta recebido');

            this.showNotification(title, {
                body: newAlert.code_alert,
                tag: newAlert.id,
                renotify: true
            })
        },
        scheduledGetVehiclesInfo(){
            const ONE_MINUTE_IN_MILLISECONDS = 60 * 1000;
            this.refreshVehiclesInfo = setInterval(() => {
                this.vehicleService.getVehiclesByOrgV3(this.selectedOrg.id).then((data) => {
                    this.gridData.forEach((item) => {
                        data.forEach((vehicle) => {
                            if(item.vin === vehicle.identification_number && vehicle.last_contact){
                                item.hour_last_communication = vehicle.last_contact
                                item.hours_without_communication = Math.floor(Date.now() / 1000) - vehicle.last_contact;
                            }
                        })
                    })
                })
            }, ONE_MINUTE_IN_MILLISECONDS);
        },
        closeScheduledGetVehiclesInfo(){
            if (this.refreshVehiclesInfo) {
                clearInterval(this.refreshVehiclesInfo);
                this.refreshVehiclesInfo = null;
            }
        },
        closeWebSocket() {
            if (this.ws) {
                this.ws.close();
                this.ws = null;
                console.log("WebSocket fechado.");
            }
        },
        transformKeys(obj) {
            if (Array.isArray(obj)) {
                return obj.map(item => this.transformKeys(item));
            } else if (typeof obj === 'object' && obj !== null) {
                return Object.keys(obj).reduce((acc, key) => {
                    const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
                    acc[newKey] = this.transformKeys(obj[key]);
                    return acc;
                }, {});
            }
            return obj;
        },
        showNotification(title, options = {}) {
            if (!('Notification' in window)) {
                return;
            }

            if (Notification.permission === 'granted') {
                new Notification(title, options);
            }
        }
    },
    watch: {
        selectedOrg: function (val) {
            this.applyHourFormatFromOrganizations(val, this.organizations)
            this.closeScheduledGetVehiclesInfo()
            this.closeWebSocket()
            this.optionsFleet = []
            this.optionsClass = []
            this.optionsFront = []
            this.optionsSensorName = []
            this.getAlertsCoa(val)
        },
    },
    computed: {
        getHeightMap() {
            if (this.form.status && this.form.status === 'FINISHED') {
                return '397px';
            }
            return '313px';
        },
        ...mapGetters([
            'user'
        ])
    },
    validations: {
        form: {
            responsible: {required},
            status: {required},
            comment: {required}
        }
    },
    components: {
        Dropdown, MultiSelect, DataTable, Column, InputText, Button, Dialog,
        AppButton, Textarea, Tooltip, AppAlertsCoaGoogleMaps, ProgressSpinner
    },
    directives: {
        tooltip: Tooltip
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";

.container-dialog {
    display: flex;
    width: 100%;
}

.container-dialog-first {
    width: 60%;
    padding: 0 15px 7.5px 0;
    border-right: 1px solid #D2D2D2;
}

.container-dialog-second {
    width: 40%;
    padding: 0 0 7.5px 15px;
}

@media (max-width: 1024px){
    .data-table-width{
        width: 100vw;
    }
}

@media (max-width: 768px){
    .container-dialog {
        display: block;
    }

    .container-dialog-first {
        width: 100%;
        padding: 0 0 20px 0;
        border: none;
        border-bottom: 1px solid #D2D2D2;
    }

    .container-dialog-second {
        width: 100%;
        padding: 5px 0 15px 0;
        border-bottom: 1px solid #D2D2D2;
    }
}

@media (min-width: 1025px){
    .data-table-width{
        max-width: calc(100vw - 140px);
    }
}
</style>
